import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Form } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { EMPTY_STRING, featureCategories } from "../../../../../constants";

const RoomsForm = ({allMustHaveAmmenities}) => {
   const {
     register,
     formState: { errors },
     watch,
     setValue,
     getValues,
   } = useFormContext();

   const featureIds = watch("amenity.featureIds");

   useEffect(() => {
     if (featureIds === false) {
       setValue("amenity.featureIds", []);
     }

     // eslint-disable-next-line
   }, [featureIds, setValue]);

  return (
    <div className="main-container-form">
      <div className="row">
        <div className="col-12 col-md-6">
          <div className="select-container">
            <label>No. of Other Rooms:</label>
            <input
              type="text"
              className={`create-list-input ${
                errors?.amenity?.otherRooms
                  ? "border border-danger"
                  : EMPTY_STRING
              }`}
              placeholder="No. of Other Rooms"
              {...register("amenity.otherRooms")}
            />
          </div>
        </div>
        <div className="col-12 col-md-6">
          <div className="select-container">
            <label>No. of Staff Quarters:</label>
            <input
              type="text"
              className={`create-list-input ${
                errors?.amenity?.staffQuarters
                  ? "border border-danger"
                  : EMPTY_STRING
              }`}
              placeholder="No. of Staff Quarters"
              {...register("amenity.staffQuarters")}
            />
          </div>
        </div>
        <div className="col-12 col-md-6">
          <div className="select-container">
            <label>No. of Kitchens:</label>
            <input
              type="text"
              className={`create-list-input ${
                errors?.amenity?.kitchens
                  ? "border border-danger"
                  : EMPTY_STRING
              }`}
              placeholder="No. of Kitchens"
              {...register("amenity.kitchens")}
            />
          </div>
        </div>
        <div className="col-12 col-md-6">
          <div className="select-container">
            <label>No. of Store Rooms:</label>
            <input
              type="text"
              className={`create-list-input ${
                errors?.amenity?.storeRooms
                  ? "border border-danger"
                  : EMPTY_STRING
              }`}
              placeholder="No. of Store Rooms"
              {...register("amenity.storeRooms")}
            />
          </div>
        </div>
        <div className="col-12 col-md-6">
          <div className="select-container">
            <label>No. of Floors:</label>
            <input
              type="text"
              className={`create-list-input ${
                errors?.amenity?.floors ? "border border-danger" : EMPTY_STRING
              }`}
              placeholder="No. of Floors"
              {...register("amenity.floors")}
            />
          </div>
        </div>
      </div>
      <div className="row">
        {errors?.amenity?.roomsIds && (
          <div className="error mt-2">{errors?.amenity?.roomsIds.message}</div>
        )}
        {allMustHaveAmmenities
          ?.filter((feature) => feature.category === featureCategories.ROOMS)
          .map((feature) => (
            <div className="col-12 col-sm-6" key={feature.id}>
              <Form.Check
                className="mb-2"
                name="mainFeatures"
                type="checkbox"
                label={feature.title}
                value={feature.id}
                onChange={(e) => {
                  const updatedValues = e.target.checked
                    ? [
                        ...(getValues("amenity.featureIds") || []),
                        Number(e.target.value),
                      ]
                    : (getValues("amenity.featureIds") || []).filter(
                        (id) => id !== Number(e.target.value)
                      );

                  setValue("amenity.featureIds", updatedValues, {
                    shouldValidate: true,
                  });
                }}
                checked={(getValues("amenity.featureIds") || []).includes(
                  feature.id
                )}
              />
            </div>
          ))}
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  allMustHaveAmmenities: state.homeReducer.allMustHaveAmmenities,
});

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(RoomsForm)
